import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MainLayout from '../../layout/MainLayout';

/* #189: Diese Seite rechnete Fallzahlschaetzung, SQL-Generierung und
   Datenextraktion komplett gegen `src/data/cohorts.json`,
   `src/data/parameters.json` und `src/data/parameterLists.json` --
   erfundene Kohorten mit erfundenen Patientenzahlen, ein SQL-Statement gegen
   eine Tabelle, die es nirgends gibt, und ein "Extraktion beantragen"-Knopf,
   der nur ins Devtools-Log schrieb. Es gibt dafuer keinen Endpunkt (das
   Cart-Backend unter `/olymp/cart/*` ist eine andere Sache: ein Warenkorb
   fuer einzelne Parameter, den nichts im Frontend befuellt). Die Ansicht
   bleibt deaktiviert, bis das nachgezogen ist.

   Nachgezogen als **#276** (Review Runde 2, B5): dort ist zu entscheiden, ob
   die Ansicht ganz entfaellt oder einen Endpunkt bekommt. Bis dahin bleibt sie
   deaktiviert -- eine Ansicht, die erfundene Zahlen zeigt, ist schlechter als
   keine. */
const DataRequests = () => {
  return (
    <MainLayout>
      <Box sx={{ flexGrow: 1 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="h4" gutterBottom fontWeight="bold">
            <AssignmentIcon sx={{ verticalAlign: 'middle', mr: 1, fontSize: 40 }} />
            Datenanfragen
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Fallzahlschätzung und Datenextraktion für Kohorten
          </Typography>
        </Box>

        <Paper sx={{ p: 6, textAlign: 'center' }}>
          <InfoOutlinedIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant="h6" gutterBottom>
            Diese Ansicht ist noch nicht verfügbar
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Es gibt dafür noch keinen Endpunkt. Nutzen Sie bis dahin „Anfragen“, um eine
            Datenextraktion für eine Kohorte zu beantragen.
          </Typography>
        </Paper>
      </Box>
    </MainLayout>
  );
};

export default DataRequests;
